module.exports = __webpack_public_path__ + "b9197e69f00cd0f998a46b0080c23229.svg";